import autoComplete from "@tarekraafat/autocomplete.js";

class CustomAutocomplete {
  constructor(el) {
    this._el = el;
    this._data = JSON.parse(el.querySelector(".js-data").innerHTML);
    this._target = el.dataset.target;

    const config = {
      selector: this._target,
      searchEngine: "loose",
      data: {
        src: this._data,
        keys: ["title", "upc"],
        cache: true,
      },
      resultsList: {
        element: (list, data) => {
          if (!data.results.length) {
            const message = document.createElement("div");
            message.setAttribute("class", "no_result");
            message.innerHTML = `<span>Found No Results for "${data.query}"</span>`;
            list.prepend(message);
          }
        },
        noResults: false,
      },
      resultItem: {
        element: (item, data) => {
          item.classList.add('relative', 'flex', 'gap-2', 'items-center', 'group');
          item.innerHTML = `
            <span class="w-20 h-20 shrink-0"><img src="${data.value.thumbnail}" alt="${data.value.title}" class="w-full h-full object-cover" /></span>
            <div>
              <span class="group-hover:underline">${data.value.title}</span>
              <br/><small>${data.value.categoryTitle}</small>
            </div>
            <a href="${data.value.url}" class="absolute inset-0 text-[0]">${data.value.title}</a>
          `;
        },
        highlight: true,
      },
    };

    new autoComplete(config);
  }
}

Array.from(document.querySelectorAll(".js-autocomplete")).forEach((element) => {
  new CustomAutocomplete(element);
});
